import { intlLocale } from '@/libs/dayjs'

/*
 * Numbers the way the reader's language writes them: "6,5" in Slovenian, "6.5" in English.
 * Hours and file sizes are the console's only fractions.
 */
export const formatNumber = (value: number, maximumFractionDigits = 1): string =>
    new Intl.NumberFormat(intlLocale(), { maximumFractionDigits }).format(value)

/** A file size: "840 B", "12,4 KB", "3,1 MB". */
export const formatSize = (bytes: number): string => {
    if (bytes < 1024)        return `${bytes} B`
    if (bytes < 1024 * 1024) return `${formatNumber(bytes / 1024)} KB`

    return `${formatNumber(bytes / 1024 / 1024)} MB`
}
